<ng-container *ngIf="user$ | async as _user">
  <ng-container *ngIf="_user.email || _user.displayFullName">
    <div class="menu-item px-3">
      <div class="menu-content d-flex align-items-center justify-content-between px-3">
        <app-initials class="flex-shrink-0 me-1 me-md-2">{{_user.initials}}</app-initials>
        <div class="d-flex flex-column mw-200px">
          <div class="fw-bolder d-flex align-items-center fs-5 text-truncate">
            {{ _user.displayFullName }}
          </div>
          <a class="fw-bold text-muted fs-7 text-truncate">
            {{ _user.email }}
          </a>
        </div>
      </div>
    </div>

    <div class="separator my-2"></div>
  </ng-container>
  <div
    ngbDropdown
    class="menu-item"
    data-kt-menu-trigger="hover"
    data-kt-menu-placement="left-start"
    data-kt-menu-flip="bottom"
  >
    <a ngbDropdownToggle class="menu-link cursor-pointer user-select-none user-inner__lang-trigger">
      <span class="menu-title position-relative">
        {{'COMMON.LANGUAGE' | translate}}
        <span
          class="
            fs-8
            rounded
            bg-light
            px-3
            py-2
            position-absolute
            translate-middle-y
            top-50
            end-0
            user-inner__lang-tag
          "
        >
          {{ i18nService.selectedLocale?.name }}{{ " " }}
        </span>
      </span>
    </a>

    <div ngbDropdownMenu class="menu-sub menu-sub-dropdown w-175px py-4">
      <div
        *ngFor="let locale of i18nService.localesShortList"
        class="menu-item px-3 cursor-pointer"
        (click)="i18nService.setLanguage(locale.lang)"
      >
        <a
          class="menu-link d-flex"
          [ngClass]="locale.lang === i18nService.selectedLang ? 'active' : ''"
        >
          {{ locale.name }}
        </a>
      </div>
    </div>
  </div>

  <!-- Accounts -->
  <ng-container *ngIf="!whiteLabelService.isWhiteLabel">
    <div class="menu-item" test-id="user-menu.accounts-list">
      <a routerLink="/accounts/list" class="menu-link cursor-pointer">
      <span class="menu-icon">
        <span
          [inlineSVG]="'./assets/media/icons/app/folder-accounts.svg'"
          class="svg-icon svg-icon-1tx"
        ></span>
      </span>
        <span class="menu-title">{{'MENU.ACCOUNT_LIST' | translate}}</span>
      </a>
    </div>
    <div class="separator my-2"></div>
  </ng-container>
  <div
    *ngIf="!_user.attributes.hidePasswordChange"
    class="menu-item"
    test-id="user-menu.change-password"
  >
    <a (click)="changePassword()" class="menu-link cursor-pointer">
      <span class="menu-icon">
      <i class="bi bi-key fs-1hx"></i>
      </span>
      <span class="menu-title">{{'COMMON.CHANGE_PASSWORD' | translate}}</span>
    </a>
  </div>
  <div class="menu-item">
    <a (click)="logout()" class="menu-link cursor-pointer">
      <span class="menu-icon">
      <i class="bi bi-box-arrow-right fs-1hx"></i>
      </span>
      <span class="menu-title">{{'COMMON.SIGN_OUT' | translate}}</span>
    </a>
  </div>
</ng-container>
